import type {
  CareplanProductDataModel,
  CareplanProductResponse,
  PreviousCareplanProductDataModel,
} from "@/domains/careplan/models/types";
import { formatAmountAsString } from "@/utils/money";

export const createCareplanProductDataModel = (product: CareplanProductResponse) => {
  const { price, ...rest } = product;

  return {
    ...rest,
    sku: product.sku,
    priceInCents: price,
    priceAsString: formatAmountAsString(`${price / 100}`),
    format: product.forms,
    details: [
      { id: 1, slug: "all-ingredients", title: "All Ingredients", body: product.facts },
      { id: 2, slug: "how-it-works", title: "How It Works", body: product.howItWorks },
      {
        id: 3,
        slug: "how-and-where-its-made",
        title: "How & Where It's Made",
        shortTitle: "How It's Made",
        body: product.howAndWhereMade,
      },
      {
        id: 4,
        slug: "safety-notes",
        title: "Safety Notes",
        body: "Dietary supplements have risks. Consult a physician before use. <br className='hidden sm:block' />This product should not be used by pregnant or breastfeeding women.",
      },
    ],
    isPrevious: false,
  };
};

export const isCurrentProduct = (
  product: CareplanProductDataModel | PreviousCareplanProductDataModel,
) => {
  return !product.isPrevious && (product as CareplanProductDataModel);
};
